import { graphql } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import "./gridNavbar.scss";
import { Container, Dropdown } from "react-bootstrap";
import { getParagraph } from "../../../utils/paragraphHelpers";

const TABS = {
  tabContent: "tabContent",
  language: "lang",
};

export const ParagraphNavLinks = ({ node }) => {
  const [toggle, setToggle] = useState("");
  const navRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (ev) =>
      navRef.current &&
      !navRef.current.contains(ev.target) &&
      dismissDropdown();
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const dismissDropdown = () => setToggle("");

  const paragraphs = node?.relationships?.field_cta_link?.map(getParagraph);
  return (
    <nav ref={navRef} className="grid-navbar">
      <Container className="general-container grid-navbar__items-wrapper">
        <div className="display-mobile">
          <Dropdown
            show={toggle === TABS.tabContent}
            className="d-inline"
            autoClose="inside"
          >
            <Dropdown.Toggle
              className="table-of-contents"
              id="dropdown-autoclose-inside"
              onClick={() => setToggle(TABS.tabContent)}
            >
              <span>{node?.field_menu_label || "Table of Contents"}</span>{" "}
              <i className="icon-table" style={{ fontSize: 22 }} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {node?.relationships?.field_jump_links?.map((jumpLink) => {
                if (jumpLink?.field_sub_menus?.length > 0) {
                  return (
                    <>
                      <div className="pt-2 bbottom">
                        <label className="ps-3 py-2">
                          {jumpLink?.field_menu_link?.title}
                        </label>
                        {jumpLink?.field_sub_menus?.map((subLink) => (
                          <Dropdown.Item
                            onClick={dismissDropdown}
                            href={subLink?.url || "/"}
                            className="ps-4"
                          >
                            {subLink?.title}
                          </Dropdown.Item>
                        ))}
                      </div>
                    </>
                  );
                } else {
                  return (
                    <Dropdown.Item
                      onClick={dismissDropdown}
                      href={jumpLink?.field_menu_link?.url || "/"}
                      className="bbottom"
                    >
                      {jumpLink?.field_menu_link?.title}
                    </Dropdown.Item>
                  );
                }
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="display-desktop">
          <ul className="">
            {node?.relationships?.field_jump_links?.map((jumpLink) => {
              if (jumpLink?.field_sub_menus?.length > 0) {
                return (
                  <Dropdown
                    show={toggle === jumpLink?.field_menu_link?.title}
                    className="d-inline"
                    autoClose="inside"
                  >
                    <Dropdown.Toggle
                      id="dropdown-autoclose-inside"
                      className="d-flex"
                      onClick={() => {
                        setToggle(jumpLink?.field_menu_link?.title);
                      }}
                    >
                      <div className="block-inline">
                        <span>{jumpLink?.field_menu_link?.title}</span>
                        <span style={{ paddingRight: 5 }} />
                        <i className="icon-caret-down" />
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {jumpLink?.field_sub_menus?.length > 0 &&
                        jumpLink?.field_sub_menus?.map((subLink) => (
                          <Dropdown.Item
                            onClick={dismissDropdown}
                            href={subLink?.url || "/"}
                            className="bbottom"
                          >
                            {subLink?.title}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              } else {
                return (
                  <li className="grid-navbar__item">
                    <a
                      onClick={dismissDropdown}
                      href={jumpLink?.field_menu_link?.url}
                    >
                      {jumpLink?.field_menu_link?.title}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>

        <div className="d-flex gap-2 align-items-center">
          {node?.field_language_menus?.length > 0 && (
            <Dropdown
              show={toggle === TABS.language}
              className="d-inline"
              autoClose="inside"
            >
              <Dropdown.Toggle
                id="dropdown-autoclose-inside"
                className="language-toggle"
                onClick={() => setToggle(TABS.language)}
              >
                <i className="icon-globe" style={{ fontSize: 24 }} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {node?.field_language_menus?.map((language) => (
                  <Dropdown.Item
                    onClick={dismissDropdown}
                    href={language?.url}
                    className="bbottom"
                  >
                    {language?.title}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}

          {paragraphs}
        </div>
      </Container>
    </nav>
  );
};

export const fragment = graphql`
  fragment ParagraphNavLinks on paragraph__navigation_links {
    relationships {
      field_jump_links {
        field_menu_link {
          title
          url
        }
        field_sub_menus {
          title
          url
        }
      }
      field_cta_link {
        type: __typename
        ...ParagraphLinks
        # field_link {
        #   title
        #   url
        #   options {
        #     attributes {
        #       aria_label
        #       class
        #       rel
        #       target
        #     }
        #   }
        # }
      }
    }
    field_language_menus {
      title
      url
    }
    field_menu_label
  }
`;

export default ParagraphNavLinks;
